import { StateParamsConfig } from "single-spa/react-app/router/utils/state-params-build/params-config";

import type { SocialChannelsParamKeys, SocialChannelsParamsDefinition } from "./routes.types";

const socialChannelsParamsDefinition: SocialChannelsParamsDefinition = {
    key: {
        type: "string",
        dynamic: false,
    },
    duration: {
        type: "string",
        value: "28d",
    },
    country: {
        type: "int",
        array: false,
        value: 840,
    },
    isWWW: {
        type: "string",
        value: "*",
    },
    adsSelectedSite: {
        type: "string",
        array: false,
        dynamic: false,
    },
    dataFilters: {
        type: "json",
        array: false,
        dynamic: true,
    },
    sort: {
        type: "string",
        value: "Recent",
    },
    adsViewType: {
        type: "int",
        array: false,
        value: 0,
    },
} as const;

export const socialChannelsParams = new StateParamsConfig<SocialChannelsParamsDefinition, SocialChannelsParamKeys>(
    socialChannelsParamsDefinition,
);

const ROOT_STATE_NAME = "social-channels";

export const ROUTES: Record<
    "ABSTRACT" | "ADS",
    { camelCase: string; kebabCase: string; stateName: string; url: string }
> = {
    ABSTRACT: {
        camelCase: "socialChannelsAbstract",
        kebabCase: "social-channels-abstract",
        stateName: ROOT_STATE_NAME,
        url: "/social-channels",
    },
    ADS: {
        camelCase: "socialChannelsAds",
        kebabCase: "social-channels-ads",
        stateName: `${ROOT_STATE_NAME}.ads`,
        url: "/ads",
    },
} as const;
